"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWarmCacheObjectKeys = void 0;
//Returns s3 key for cached result, the bucket to use will always be [projectCode]-[stage]-warm-cache as per service definition
const getWarmCacheObjectKeys = ({ partition, key }) => {
    let s3Key = null;
    if (partition === 'dashboard') {
        s3Key = `${partition}/${key}`;
    }
    return s3Key;
};
exports.getWarmCacheObjectKeys = getWarmCacheObjectKeys;
